import http from 'utils/http';

export const fetchTasks = (companyId) => http
  .get(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/`)
  .then((res) => res.data);

export const createTask = (companyId, data) => {
  const formData = new FormData();
  formData.append('company', companyId);
  if (data.contact) formData.append('contact', data.contact);
  if (data.assignee) formData.append('assignee', data.assignee);
  if (data.title) formData.append('title', data.title);
  if (data.description) formData.append('description', data.description);
  if (data.due_date) formData.append('due_date', data.due_date);

  return http
    .post(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/`, formData)
    .then((res) => res.data);
};

export const updateTask = (companyId, taskId, data) => {
  const formData = new FormData();
  if (data.contact) formData.append('contact', data.contact);
  if (data.assignee) formData.append('assignee', data.assignee);
  if (data.title) formData.append('title', data.title);
  if (data.description) formData.append('description', data.description);
  if (data.due_date) formData.append('due_date', data.due_date);

  return http
    .put(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/${taskId}/`, formData)
    .then((res) => res.data);
};

export const completeTask = (companyId, taskId) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/${taskId}/complete/`)
  .then((res) => res.data);

export const reopenTask = (companyId, taskId) => http
  .post(`v1/organizations/{{organizationId}}/companies/${companyId}/tasks/${taskId}/reopen/`)
  .then((res) => res.data);
